import React from 'react'
import PropTypes from 'prop-types'

const Substack = ({ substackFrameUrl }) => {
  return (
    <iframe
      title="substack"
      src={substackFrameUrl}
      width="100%"
      height="300"
      style={{ border: '1px solid #EEE', background: 'white' }}
      frameBorder="0"
      scrolling="no"
    />
  )
}

Substack.propTypes = {
  substackFrameUrl: PropTypes.string
}

export default Substack
